import {
    GET_TERRAINS,
    GET_TERRAINS_SUCCESS,
    STORE_TERRAIN_REQUEST,
    STORE_TERRAIN_SUCCESS,
    STORE_TERRAIN_FAILURE,
    DELETE_TERRAIN_REQUEST,
    DELETE_TERRAIN_SUCCESS,
    DELETE_TERRAIN_FAILURE,
    GET_TERRAIN_REQUEST,
    GET_TERRAIN_SUCCESS,
    GET_TERRAIN_FAILURE,
    POST_TERRAIN_STAFF_REQUEST,
    POST_TERRAIN_STAFF_SUCCESS,
    POST_TERRAIN_STAFF_FAILURE,
    GET_TERRAIN_PLANNING_REQUEST,
    GET_TERRAIN_PLANNING_SUCCESS,
    GET_TERRAIN_PLANNING_FAILURE,
    GET_TERRAINS_ASSESSMENT_REQUEST,
    GET_TERRAINS_ASSESSMENT_SUCCESS,
    GET_TERRAINS_ASSESSMENT_FAILURE,
    GET_TERRAINS_STAFF_MATCHING_REQUEST,
    GET_TERRAINS_STAFF_MATCHING_SUCCESS,
    GET_TERRAINS_STAFF_MATCHING_FAILURE,
    POST_TERRAINS_AUTO_STAFF_MATCHING_REQUEST,
    POST_TERRAINS_AUTO_STAFF_MATCHING_SUCCESS,
    POST_TERRAINS_AUTO_STAFF_MATCHING_FAILURE,
    POST_TERRAINS_STAFF_CONFIRMATION_REQUEST,
    POST_TERRAINS_STAFF_CONFIRMATION_SUCCESS,
    POST_TERRAINS_STAFF_CONFIRMATION_FAILURE,
    POST_TERRAINS_AUTO_STAFF_MATCHING_TRACKING_REQUEST,
    POST_TERRAINS_AUTO_STAFF_MATCHING_TRACKING_SUCCESS,
    POST_TERRAINS_AUTO_STAFF_MATCHING_TRACKING_FAILURE,
    POST_TALENT_ASSESSMENT_ACTION_REQUEST,
    POST_TALENT_ASSESSMENT_ACTION_SUCCESS,
    POST_TALENT_ASSESSMENT_ACTION_FAILURE,
    POST_TERRAIN_STATS_DAILY_REQUEST,
    POST_TERRAIN_STATS_DAILY_SUCCESS,
    POST_TERRAIN_STATS_DAILY_FAILURE,
    POST_TERRAIN_STAFF_ADD_REQUEST,
    POST_TERRAIN_STAFF_ADD_SUCCESS,
    POST_TERRAIN_STAFF_ADD_FAILURE
} from '../action-types'


export const getTerrains = (token) => {
    return {
        type: GET_TERRAINS,
        token: token,
    }
}

export const getTerrainsSuccess = (data) => {
    return {
        type: GET_TERRAINS_SUCCESS,
        data: data?.data,
    }
}

export const storeTerrain = (token, terrainData) => {
    return {
        type: STORE_TERRAIN_REQUEST,
        token: token,
        terrainData: terrainData,
    }
}

export const storeTerrainSuccess = (data) => {
    return {
        type: STORE_TERRAIN_SUCCESS,
        data: data,
    }
}

export const storeTerrainFailure = (error) => {
    return {
        type: STORE_TERRAIN_FAILURE,
        error: error,
    }
}

export const deleteTerrain = (token, terrainId) => {
    return {
        type: DELETE_TERRAIN_REQUEST,
        token: token,
        terrainId: terrainId,
    }
}

export const deleteTerrainSuccess = (data) => {
    return {
        type: DELETE_TERRAIN_SUCCESS,
        data: data,
    }
}

export const deleteTerrainFailure = (error) => {
    return {
        type: DELETE_TERRAIN_FAILURE,
        error: error,
    }
}

export const getTerrain = (token, terrainId) => {
    return {
        type: GET_TERRAIN_REQUEST,
        token: token,
        terrainId: terrainId,
    }
}

export const getTerrainSuccess = (data) => {
    return {
        type: GET_TERRAIN_SUCCESS,
        data: data,
    }
}

export const getTerrainFailure = (error) => {
    return {
        type: GET_TERRAIN_FAILURE,
        error: error,
    }
}

export const postTerrainStaff = (token, terrainId, staffData) => {
    return {
        type: POST_TERRAIN_STAFF_REQUEST,
        token: token,
        terrainId: terrainId,
        staffData: staffData,
    }
}

export const postTerrainStaffSuccess = (data) => {
    return {
        type: POST_TERRAIN_STAFF_SUCCESS,
        data: data,
    }
}

export const postTerrainStaffFailure = (error) => {
    return {
        type: POST_TERRAIN_STAFF_FAILURE,
        error: error,
    }
}

export const getTerrainPlanning = (token, params) => {
    return {
        type: GET_TERRAIN_PLANNING_REQUEST,
        token: token,
        params: params,
    }
}

export const getTerrainPlanningSuccess = (data) => {
    return {
        type: GET_TERRAIN_PLANNING_SUCCESS,
        data: data,
    }
}

export const getTerrainPlanningFailure = (error) => {
    return {
        type: GET_TERRAIN_PLANNING_FAILURE,
        error: error,
    }
}

export const getTerrainsAssessment = (token, params) => {
    return {
        type: GET_TERRAINS_ASSESSMENT_REQUEST,
        token: token,
        params: params,
    }
}

export const getTerrainsAssessmentSuccess = (data) => {
    return {
        type: GET_TERRAINS_ASSESSMENT_SUCCESS,
        data: data,
    }
}

export const getTerrainsAssessmentFailure = (error) => {
    return {
        type: GET_TERRAINS_ASSESSMENT_FAILURE,
        error: error,
    }
}

export const getTerrainsStaffMatching = (token, params) => {
    return {
        type: GET_TERRAINS_STAFF_MATCHING_REQUEST,
        token: token,
        params: params,
    }
}

export const getTerrainsStaffMatchingSuccess = (data) => {
    return {
        type: GET_TERRAINS_STAFF_MATCHING_SUCCESS,
        data: data,
    }
}

export const getTerrainsStaffMatchingFailure = (error) => {
    return {
        type: GET_TERRAINS_STAFF_MATCHING_FAILURE,
        error: error,
    }
}

export const postTerrainsAutoStaffMatching = (token, params) => {
    return {
        type: POST_TERRAINS_AUTO_STAFF_MATCHING_REQUEST,
        token: token,
        params: params,
    }
}

export const postTerrainsAutoStaffMatchingSuccess = (data) => {
    return {
        type: POST_TERRAINS_AUTO_STAFF_MATCHING_SUCCESS,
        data: data,
    }
}

export const postTerrainsAutoStaffMatchingFailure = (error) => {
    return {
        type: POST_TERRAINS_AUTO_STAFF_MATCHING_FAILURE,
        error: error,
    }
}

export const postTerrainsStaffConfirmation = (token, params) => {
    return {
        type: POST_TERRAINS_STAFF_CONFIRMATION_REQUEST,
        token: token,
        params: params,
    }
}

export const postTerrainsStaffConfirmationSuccess = (data) => {
    return {
        type: POST_TERRAINS_STAFF_CONFIRMATION_SUCCESS,
        data: data,
    }
}

export const postTerrainsStaffConfirmationFailure = (error) => {
    return {
        type: POST_TERRAINS_STAFF_CONFIRMATION_FAILURE,
        error: error,
    }
}

export const postTerrainsAutoStaffMatchingTracking = (token, params) => {
    return {
        type: POST_TERRAINS_AUTO_STAFF_MATCHING_TRACKING_REQUEST,
        token: token,
        params: params,
    }
}

export const postTerrainsAutoStaffMatchingTrackingSuccess = (data) => {
    return {
        type: POST_TERRAINS_AUTO_STAFF_MATCHING_TRACKING_SUCCESS,
        data: data,
    }
}

export const postTerrainsAutoStaffMatchingTrackingFailure = (error) => {
    return {
        type: POST_TERRAINS_AUTO_STAFF_MATCHING_TRACKING_FAILURE,
        error: error,
    }
}

export const postTalentAssessmentAction = (token, params) => {
    return {
        type: POST_TALENT_ASSESSMENT_ACTION_REQUEST,
        token: token,
        params: params,
    }
}

export const postTalentAssessmentActionSuccess = (data) => {
    return {
        type: POST_TALENT_ASSESSMENT_ACTION_SUCCESS,
        data: data,
    }
}

export const postTalentAssessmentActionFailure = (error) => {
    return {
        type: POST_TALENT_ASSESSMENT_ACTION_FAILURE,
        error: error,
    }
}

export const postTerrainStatsDaily = (token, params) => {
    return {
        type: POST_TERRAIN_STATS_DAILY_REQUEST,
        token: token,
        params: params,
    }
}

export const postTerrainStatsDailySuccess = (data) => {
    return {
        type: POST_TERRAIN_STATS_DAILY_SUCCESS,
        data: data,
    }
}

export const postTerrainStatsDailyFailure = (error) => {
    return {
        type: POST_TERRAIN_STATS_DAILY_FAILURE,
        error: error,
    }
}

export const postTerrainStaffAdd = (token, staffData) => {
    return {
        type: POST_TERRAIN_STAFF_ADD_REQUEST,
        token: token,
        staffData: staffData,
    }
}

export const postTerrainStaffAddSuccess = (data) => {
    return {
        type: POST_TERRAIN_STAFF_ADD_SUCCESS,
        data: data,
    }
}

export const postTerrainStaffAddFailure = (error) => {
    return {
        type: POST_TERRAIN_STAFF_ADD_FAILURE,
        error: error,
    }
}